module.exports = __webpack_public_path__ + "static/media/send.be2a021f.svg";